import React, { useState } from "react"
import { Link } from "gatsby"
import { Box, Flex } from "@theme-ui/components"
import DesignTokens from "./designTokens"
import I18nSlug from "./i18nSlug"
import { getPagePath, getBlogPath } from "./pathUtils"
import { LanguageContext } from "../locales/langContext"

const DropdownMobileNav = ({ anchor, links, path, onApplicationsClick }) => {
  const [showMenu, setShowMenu] = useState(false)
  const isBrowser = typeof window !== "undefined"
  const isActive = isBrowser && window.location.href.indexOf(path) > -1

  const handleClick = () => {
    if (anchor === "Applicazioni" && onApplicationsClick) {
      onApplicationsClick()
    } else {
      setShowMenu(!showMenu)
    }
  }

  return (
    <Box
      as="li"
      onClick={handleClick}
      sx={{
        width: "100%",
        marginBottom: 0,
        "&:last-child > a": {
          paddingRight: 0,
        },
        a: {
          textDecoration: "none",
        },
      }}
    >
      <Link
        style={{
          borderBottom: isActive ? "2px solid #00793D" : "none",
          fontWeight: isActive ? "bold" : "normal",
          cursor: "default",
          textAlign: "start",
        }}
      >
        {anchor}
      </Link>

      {showMenu && (
        <Flex
          as="ul"
          sx={{
            marginLeft: 0,
            marginTop: "1rem",
            textAlign: "left",
            borderTop: "1px solid #198a52",
            borderBottom: "1px solid #198a52",
            paddingBottom: "1rem",
            position: "relative",
            flexDirection: "column",
            "& > li": {
              display: "inline-flex",
              margin: 0,
              padding: 0,
              a: {
                width: "100%",
                fontSize: DesignTokens.fontSizes[3],
                padding: `${DesignTokens.spacing[2]} ${DesignTokens.spacing[4]}`,
                color: "#ffffff",
                textDecoration: "none",
                "&:hover": {
                  color: "#ffffff",
                  backgroundColor: "#00793D",
                },
              },
            },
          }}
        >
          {links.map(link => (
            <Box as="li" key={link.id}>
              {link.link && link.link.__typename === "DatoCmsPageLink" && (
                <I18nSlug
                  path={
                    link.link.page.treeParent
                      ? link.link.page.treeParent.slug
                      : path
                  }
                  slug={link.link.page.slug}
                >
                  {link.name}
                </I18nSlug>
              )}
              {link.link && link.link.__typename === "DatoCmsLink" && (
                <a
                  href={link.link.url}
                  target={link.link.openInNewWindow ? "_blank" : "_self"}
                  rel={
                    link.link.openInNewWindow
                      ? "noopener noreferrer"
                      : undefined
                  }
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  {link.name}
                </a>
              )}
              {!link.link && (
                <I18nSlug
                  path={path}
                  slug={
                    link.slug ||
                    link.page.treeParent.slug.toLowerCase().replace(/\s+/g, "-")
                  }
                >
                  {link.title || link.name}
                </I18nSlug>
              )}
              {link.model && link.model.apiKey === "page" && (
                <Link
                  to={`/${getPagePath(link)}`}
                  activeStyle={{
                    borderBottom: "2px solid #00793D",
                    fontWeight: "bold",
                  }}
                  partiallyActive
                >
                  {link.title || link.name}
                </Link>
              )}
            </Box>
          ))}
        </Flex>
      )}
    </Box>
  )
}

export default DropdownMobileNav
